import { CURRENCIES } from './konstants.js'

export function validateCurrency(iso3: string): string | undefined {
  return CURRENCIES.find((c) => c === String(iso3).toUpperCase())
}
